/**
 * BRINUTI – Pénztári dizájnkép, böngészős rész
 *
 * A pénztárban a vásárló saját terve a Cart Transform függvénnyel
 * (apps/penztar-dizajnkep) jelenik meg, de a Shopify ott csak cdn.shopify.com
 * képet fogad el. A bolt a kosár-előnézetet már feltölti a Teeinblue
 * tárolójára (_brinuti_elonezet); ez a szkript ennek a képnek kér egy Shopify
 * Files másolatot (docs/penztar-dizajnkep/Kod.gs), és a címét a kosársorra
 * írja _brinuti_kep néven. A függvény csak azt a sort bontja ki, amelyiken ez
 * megvan, így ami nem készült el, az egyszerűen a régi képpel megy tovább.
 *
 * Minden vásárlónál fut (élesítve: 2026-10-01).
 */
(function () {
  'use strict';

  var VEGPONT = 'https://script.google.com/macros/s/AKfycbz1ZeUZrCYasc4pbjpnbrKyShTNP65j-DZDxDJATXU_BHRijw-y-O8mD3nSKGJJ8E_A/exec';   // az Apps Script webapp /exec címe (TELEPITES.md)
  var FORRAS = 'https://s3.eu-central-2.wasabisys.com/teeinblue-cdn-we/';
  /* 2026-11-03: a Teeinblue feltöltője november 2. óta Cloudflare R2 tárolót használ; a levélkép
     (_brinuti_elonezet) ilyenkor a https://cdnx.teeinblue.com/r2/… címen van (a Worker /relay/r2 útvonalán át,
     hibanapló #43). Mindkét tároló címe jó forrás a másolónak. */
  var FORRAS_R2 = 'https://cdnx.teeinblue.com/r2/customers/uploads/';
  function forrasE(cim) { return cim.indexOf(FORRAS) === 0 || cim.indexOf(FORRAS_R2) === 0; }
  var TERKEP = 'brinuti-kep-terkep';
  var CDNRE = new RegExp("^https://cdn\.shopify\.com/");

  function tarol(mit, kulcs, ertek) {
    try {
      if (ertek === undefined) return mit.getItem(kulcs);
      if (ertek === null) mit.removeItem(kulcs); else mit.setItem(kulcs, ertek);
    } catch (e) { }
    return null;
  }

  if (!VEGPONT) return;

  var folyamatban = {};

  function terkep() {
    try { return JSON.parse(tarol(localStorage, TERKEP) || '{}'); } catch (e) { return {}; }
  }

  function jelezd(nev) {
    try { if (window.clarity) window.clarity('event', nev); } catch (e) { }
  }

  function kosar(kesz) {
    try {
      var x = new XMLHttpRequest();
      x.open('GET', '/cart.js?bk=' + Date.now(), true);
      x.onload = function () {
        var k = null;
        try { k = JSON.parse(x.responseText); } catch (e) { }
        kesz(k);
      };
      x.onerror = function () { kesz(null); };
      x.send();
    } catch (e) { kesz(null); }
  }

  function irdASorra(tetel, cim) {
    var tul = {};
    Object.keys(tetel.properties).forEach(function (k) { tul[k] = tetel.properties[k]; });
    tul._brinuti_kep = cim;
    try {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/change.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.send(JSON.stringify({ id: tetel.key, quantity: tetel.quantity, properties: tul }));
    } catch (e) { }
  }

  // Hibakereséshez: az utolsó hiba rejtett kosár-tulajdonságba kerül (/cart.js-ben
  // látszik, a rendelésre nem megy át).
  function diag(szoveg) {
    try {
      var x = new XMLHttpRequest();
      x.open("POST", "/cart/update.js", true);
      x.setRequestHeader("Content-Type", "application/json");
      x.send(JSON.stringify({ attributes: { _bk_diag: String(szoveg).slice(0, 180) } }));
    } catch (e) { }
  }

  function kerdMasolatot(forras, azon, kesz) {
    var kerdes = { u: forras, i: azon };
    // text/plain: nincs CORS-előrepillantás, az Apps Script így fogadja.
    fetch(VEGPONT, { method: "POST", body: JSON.stringify(kerdes), redirect: "follow" })
      .then(function (v) { return v.text().then(function (t) { return { st: v.status, t: t }; }); })
      .then(function (r) {
        var j = null;
        try { j = JSON.parse(r.t); } catch (e) { }
        if (!(j && j.ok && CDNRE.test(j.url))) diag("valasz " + r.st + ": " + r.t.slice(0, 120));
        kesz(j && j.ok && CDNRE.test(j.url) ? j.url : "");
      })
      .catch(function (e) { diag("fetch hiba: " + (e && e.message)); kesz(""); });
  }

  /* 2026-10-16 (a tulaj jelezte: a kosárban szürke napló, a pénztárban zöld):
     szerkesztéskor a Teeinblue az új sorra átmásolja a RÉGI sor rejtett
     adatait, köztük a régi pénztárképet. A Files-másolat neve a terv
     azonosítóját tartalmazza (Kod.gs: brinuti-terv-<azon>-…), így ebből
     látszik, hogy a kép a MOSTANI tervhez tartozik-e. */
  function frissKep(t) {
    return !!(t._brinuti_kep && t._customization_id && t._brinuti_kep.indexOf(t._customization_id) >= 0);
  }

  function ellenorizd() {
    kosar(function (k) {
      if (!k || !k.items) return;
      k.items.forEach(function (tetel) {
        var t = tetel.properties || {};
        var forras = t._brinuti_elonezet || '';
        // Régi (másik tervhez tartozó) kép: azonnal levesszük, hogy a pénztár
        // inkább a Teeinblue alapképét mutassa, mint egy rossz tervet.
        if (t._customization_id && t._brinuti_kep && !frissKep(t)) { irdASorra(tetel, ''); kesobb(1500); return; }
        if (!forrasE(forras) || !t._customization_id) return;
        var meglevo = terkep()[forras];
        if (meglevo && t._brinuti_kep === meglevo) return;     // rendben
        if (folyamatban[forras]) return;
        if (meglevo) { irdASorra(tetel, meglevo); return; }    // a Teeinblue letörölte
        // legfeljebb 3 próbálkozás tervenként, hogy hiba esetén ne pörögjön
        var szam = Number(tarol(sessionStorage, 'bk-' + forras) || 0);
        if (szam >= 3) return;
        tarol(sessionStorage, 'bk-' + forras, String(szam + 1));
        folyamatban[forras] = true;
        kerdMasolatot(forras, t._customization_id, function (cim) {
          delete folyamatban[forras];
          if (!cim) { jelezd('penztar_kep_hiba'); return; }
          var t2 = terkep();
          t2[forras] = cim;
          // a térkép ne nőjön a végtelenségig
          var kulcsok = Object.keys(t2);
          if (kulcsok.length > 20) delete t2[kulcsok[0]];
          tarol(localStorage, TERKEP, JSON.stringify(t2));
          jelezd('penztar_kep_kesz');
          kosar(function (uj) {      // a sor kulcsa közben változhatott
            ((uj && uj.items) || []).forEach(function (m) {
              if (m.properties && m.properties._brinuti_elonezet === forras) irdASorra(m, cim);
            });
          });
        });
      });
    });
  }

  var kesleltetes = null;
  function kesobb(ms) {
    clearTimeout(kesleltetes);
    kesleltetes = setTimeout(ellenorizd, ms);
  }

  // Kosárba tétel vagy módosítás után (a saját /cart/change írásunk is ide
  // tartozik, de utána már minden rendben van, így nem pörög).
  try {
    new PerformanceObserver(function (lista) {
      lista.getEntries().forEach(function (e) {
        if (/\/cart\/(add|change|update)/.test(e.name)) kesobb(1000);
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) { }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) kesobb(800);
  });
  // Pénztárba lépés előtt megvárjuk a másolatot (általában ~10 mp), hogy aki
  // gyorsan kattint, ne a TeeInBlue alapképét lássa. Csak akkor tartjuk fel a
  // kattintást, ha tényleg hiányzik valamelyik kép; max. 20 mp, utána megy tovább.
  var atengedve = false;
  function hianyzik(k) {
    return ((k && k.items) || []).some(function (tetel) {
      var t = tetel.properties || {};
      var forras = t._brinuti_elonezet || '';
      if (!forrasE(forras) || !t._customization_id) return false;
      // Szalagváltáskor (2026-10-16) új levélkép készül, a régi pénztárkép
      // pedig még ehhez a tervhez tartozik — amíg az új másolat készül, várunk.
      if (folyamatban[forras]) return true;
      if (frissKep(t)) return false;
      return Number(tarol(sessionStorage, 'bk-' + forras) || 0) < 3 || !!folyamatban[forras];
    });
  }
  function varjRaMajd(kesz) {
    var kezdet = Date.now();
    (function kor() {
      kosar(function (k) {
        if (!k || !hianyzik(k) || Date.now() - kezdet > 20000) { kesz(); return; }
        ellenorizd();
        setTimeout(kor, 1200);
      });
    })();
  }
  window.addEventListener('click', function (e) {
    var gomb = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!gomb) return;
    if (atengedve) { atengedve = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    var volt = gomb.getAttribute('aria-busy');
    gomb.setAttribute('aria-busy', 'true');
    varjRaMajd(function () {
      if (!volt) gomb.removeAttribute('aria-busy');
      atengedve = true;
      gomb.click();
    });
  }, true);

  // A köztes oldal („Szettben kérem”) a naplót a vásárló saját tervével mutassa.
  // Az oldal innerHTML-lel kerül be, és a terv előnézete olykor csak utána készül
  // el, ezért a kosár aktuális állapotából cseréljük a képet.
  function sajatKepACsomagban(hely) {
    var kulcs = hely.getAttribute("data-bko-naplo-sor");
    kosar(function (k) {
      var items = (k && k.items) || [];
      var tetel = items.filter(function (t) { return t.key === kulcs; })[0] ||
        items.filter(function (t) { return t.properties && (t.properties._brinuti_kep || t.properties._brinuti_elonezet); })[0];
      var p = (tetel && tetel.properties) || {};
      var cim = p._brinuti_kep || p._brinuti_elonezet;
      if (!cim) return;
      var kep = hely.querySelector("img");
      if (!kep) { kep = document.createElement("img"); kep.alt = ""; hely.appendChild(kep); }
      if (kep.getAttribute("src") !== cim) { kep.removeAttribute("srcset"); kep.removeAttribute("sizes"); kep.src = cim; }
    });
  }
  try {
    new MutationObserver(function (listak) {
      listak.forEach(function (l) {
        Array.prototype.forEach.call(l.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          var hely = n.matches && n.matches("[data-bko-naplo-sor]") ? n : (n.querySelector && n.querySelector("[data-bko-naplo-sor]"));
          if (hely) sajatKepACsomagban(hely);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { }

  /* 2026-10-21 (a tulaj kérése): a hiányzó levélkép okának felderítéséhez a
     jelzés mostantól azt is megmondja, mi van a böngészőben ehhez a sorhoz:
     ls = van mentett pillanatkép, cim = van feltöltött levélkép-cím, fg = van
     függő mentés, p = hány pótló próbálkozás volt ebben a munkamenetben,
     hiba = a levélkép-készítés utolsó hibája, n/i = a kosár sorainak száma és
     a hiányzó sor sorszáma. Személyes adat nincs benne. */
  function allapot(azon, n, i) {
    var r = ["n=" + n, "i=" + i];
    function ls(kulcs) { try { return localStorage.getItem(kulcs) ? 1 : 0; } catch (e) { return "err"; } }
    r.push("ls=" + ls("brinuti-elo:" + azon), "cim=" + ls("brinuti-elo-cim:" + azon), "fg=" + ls("brinuti-elo-fuggo"));
    try { r.push("p=" + (sessionStorage.getItem("bl-potlo-" + azon) || 0)); } catch (e) { r.push("p=err"); }
    try { var h = sessionStorage.getItem("bl-hiba"); if (h) r.push("hiba=" + h); } catch (e) { }
    return r.join(" ");
  }

  setTimeout(function () {
    kosar(function (k) {
      if (k && k.attributes && k.attributes._bk_diag) return;
      var tetelek = (k && k.items) || [];
      for (var i = 0; i < tetelek.length; i++) {
        var p = tetelek[i].properties || {};
        if (p._customization_id && !p._brinuti_elonezet) {
          diag("nincs elonezet 25s utan; " + allapot(p._customization_id, tetelek.length, i) + "; " + navigator.userAgent.slice(0, 70));
          return;
        }
      }
    });
  }, 25000);

  kesobb(800);
  setTimeout(ellenorizd, 9000);   // a Teeinblue késői írása után
})();
